const OnMail = function() {
  const user_ids = this.collection.selected_rows
  alert(`It will email to ${user_ids.join(",")}`)
}
export default OnMail